import { AxiosError } from 'axios';

import { GetZeePersonaDataApiResponse } from '@/actions/zee-persona-data/getZeePersonaData';
import { ZEE_PERSONA_DATA_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { CreateZeePersonaDataPayload } from '@/types/zee-persona-data.type';

export const createZeePersonaData = async (
  payload: CreateZeePersonaDataPayload
): Promise<ApiResponse<GetZeePersonaDataApiResponse>> => {
  try {
    const response = await apiManager.post(ZEE_PERSONA_DATA_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200 && response.status !== 201) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
